import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroFuenteDatosService {
  private readonly fuenteDatosUrl: string;

  constructor(private httpClient: HttpClient) {
    this.fuenteDatosUrl = environment.apiUrl + '/administrador/fuente-datos/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.fuenteDatosUrl);
  }
}
